import React, { useContext } from 'react';
import { AuthorizationCodeCallback } from "react-oauth2-auth-code-flow";
import {oauthClient, scopes} from 'Auth';
import { AppContext } from 'AppContext';
import classes from 'pages/Auth/login.module.css';
import LoaderAnimation from "pages/LoaderAnimation";

import { Link } from "react-router-dom";
function SignInOidc() {
  const { setOauth } = useContext(AppContext);
  const handleSuccess = async (accessToken, { response, state }) => {
    // console.log("Successfully authorized");
    // console.log('response');
    // console.log(response);
    // console.log('accessToken');
    // console.log(accessToken);
    // debugger    
    localStorage.setItem('refreshToken',accessToken.refreshToken);
    localStorage.setItem('accessToken',accessToken.accessToken);
    localStorage.removeItem('code_verifier');
    //redirect
    // <Link to="/dashboard" />
    window.location.href = '/landing';
  };
  
  // localStorage.clear()
  const handleError = (error) => {
    console.error("An error occurred");
    console.error(error.message);
  };

  return (
    <div className={classes.login}>
      <AuthorizationCodeCallback
        oauthClient={oauthClient}
        onAuthSuccess={handleSuccess}
        onAuthError={handleError}
        render={({ processing, state, error }) => (
          <div >
            {processing && <LoaderAnimation />}
            {error && (
              <p className="error">An error occurred: {error.message}</p>
            )}
          </div>
        )}
        />
    </div>
  );
}

export default SignInOidc;
